import { createAction } from 'redux-act';

/** Полезная нагрузка формы дивидендов/купонов (универсальная форма «Добавить оценку»). */
export type ActiveMultiPaymentFormPayload = Record<string, unknown> | null;

export const setActiveMultiPaymentModalVisible = createAction<boolean>(
  'SET_ACTIVE_MULTI_PAYMENT_MODAL_VISIBLE'
);
export const setActiveMultiPaymentForm = createAction<ActiveMultiPaymentFormPayload>(
  'SET_ACTIVE_MULTI_PAYMENT_FORM'
);
